<div class="flex flex-row flex-wrap gap-[8px] justify-start items-start">
  <ng-template #dynamicMetadataComponentContainer></ng-template>
</div>
